import { TResource } from '../../../../../shared/types/utilityTypes';
import { TRealmsClientState } from '../libs/store';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';

// Action Types
export const UPDATE_REALMS_DATA = 'UPDATE_REALMS_DATA';
export const UPDATE_REALMS_DATA_LOADING = 'UPDATE_REALMS_DATA_LOADING';
export const UPDATE_REALMS_DATA_ERROR = 'UPDATE_REALMS_DATA_ERROR';
export const UPDATE_REALMS_SEARCH_DATA = 'UPDATE_REALMS_SEARCH_DATA';

export const UPDATE_REALM_DATA = 'UPDATE_REALM_DATA';
export const UPDATE_REALM_DATA_LOADING = 'UPDATE_REALM_DATA_LOADING';
export const UPDATE_REALM_DATA_ERROR = 'UPDATE_REALM_DATA_ERROR';

export type TUpdateRealmDataAction = TAction<TRealmsClientState>;
export type TUpdateRealmDataActionLoading = TAction<boolean>;
export type TUpdateRealmDataActionError = TAction<Error>;
export type TLoadRealmSearchDataAction = TAction<TResource[]>;

// Action Creators
const RealmActionCreator = {
  updateRealmsListing(clientState: TRealmsClientState): TUpdateRealmDataAction {
    return {
      type: UPDATE_REALMS_DATA,
      payload: clientState
    };
  },

  updateRealmListing(clientState: TRealmsClientState): TUpdateRealmDataAction {
    return {
      type: UPDATE_REALM_DATA,
      payload: clientState
    };
  },

  updateRealmsListingLoading(loading: boolean): TUpdateRealmDataActionLoading {
    return {
      type: UPDATE_REALMS_DATA_LOADING,
      payload: loading
    };
  },

  updateRealmListingLoading(loading: boolean): TUpdateRealmDataActionLoading {
    return {
      type: UPDATE_REALMS_DATA_LOADING,
      payload: loading
    };
  },

  updateRealmsListingError(error: Error): TUpdateRealmDataActionError {
    return {
      type: UPDATE_REALM_DATA_ERROR,
      payload: error
    };
  },

  updateRealmListingError(error: Error): TUpdateRealmDataActionError {
    return {
      type: UPDATE_REALM_DATA_ERROR,
      payload: error
    };
  },

  updateRealmSearchData(realms: TResource[]): TLoadRealmSearchDataAction {
    return {
      type: UPDATE_REALMS_SEARCH_DATA,
      payload: realms
    };
  }
};

export default RealmActionCreator;
